import React from "react";
import { ErrorBoundary } from "@sentry/react";

import HorizontalNav from "./vertical_nav_new/HorizontalNav";
import { VerticalNavNew } from "./vertical_nav_new/VerticalNav";
import { ErrorBoundaryFallback } from "./ErrorBoundaryFallback";
import SmallScreenWarning from "./SmallScreenWarning";

type AppContentLayoutProps = {
  hideMenuItems?: boolean;
  hideNavBar?: boolean;
  displayCustomAction?: React.ReactNode;
  disableLogoNav?: boolean;
  routePathname?: string; // SPA route path, passed through to VerticalNavNew for laptop-tier collapse-on-navigate. Only AppShell.tsx (SPA) has a route to pass; AppLayout.tsx (legacy) leaves this undefined.
  children: React.ReactNode;
};

function AppContentLayout({
  hideMenuItems,
  hideNavBar,
  displayCustomAction,
  disableLogoNav,
  routePathname,
  children,
}: AppContentLayoutProps) {
  // !displayCustomAction is due to feature flag, pages should be updated to have hideMenuItems as needed later
  if (hideMenuItems && !displayCustomAction) {
    return (
      <>
        <SmallScreenWarning />
        <HorizontalNav disableLogoNav={disableLogoNav} />
        <ErrorBoundary showDialog fallback={(props) => <ErrorBoundaryFallback {...props} />}>
          {children}
        </ErrorBoundary>
      </>
    );
  }

  return (
    <>
      <SmallScreenWarning />
      <VerticalNavNew hideNavBar={hideNavBar} routePathname={routePathname}>
        <ErrorBoundary showDialog fallback={(props) => <ErrorBoundaryFallback {...props} />}>
          {children}
        </ErrorBoundary>
      </VerticalNavNew>
    </>
  );
}

export default AppContentLayout;
